<template>
  <div class="box">
    <p v-if="active || findParam(item.tempCommand.parameters)">
      <a
        class="title is-5 is-unselectable"
        @click="
          clean(item);
          active = false;
        "
        data-tooltip="Click to remove"
      >
        <span v-show="findParam(item.tempCommand.parameters)">
          <span class="icon has-text-success">
            <i class="mdi mdi-check has-text-success"></i>
          </span>
        </span>
        Package parameters
        <span class="icon">
          <i class="mdi mdi-chevron-up"></i>
        </span>
      </a>
    </p>

    <a
      class="title is-5 is-unselectable"
      v-if="!active && !findParam(item.tempCommand.parameters)"
      @click="active = true"
      data-tooltip="Click to add"
    >
      Package parameters (none)
      <span class="icon">
        <i class="mdi mdi-chevron-down"></i>
      </span>
    </a>

    <div
      v-if="active || findParam(item.tempCommand.parameters)"
      class="extrapadding"
    >
      <section v-if="!findParam(item.tempCommand.parameters)">
        <div class="control">
          <input
            id="param"
            class="input"
            :class="{
              'is-warning': !isValid,
              'is-success': isValid,
            }"
            name="param"
            type="text"
            placeholder='Package parameters eg. /something /key:value /key:"some value with space"'
            value=""
            @input="validate($event.target.value)"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            @keydown.enter="isValid && addTempParam(item, parameter)"
          />
        </div>
        <button
          :disabled="!isValid"
          @click="isValid && addTempParam(item, parameter)"
          class="button margin-top-10 is-success is-small"
        >
          Add
        </button>
      </section>
      <section v-if="findParam(item.tempCommand.parameters)">
        <pre>{{ findParam(item.tempCommand.parameters) }}</pre>
        <button
          @click="clean(item)"
          class="button margin-top-10 is-danger is-small"
        >
          Reset
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import { addTempParam, findParam } from "@/utils/packages";

export default {
  components: {},
  props: { item: Object, isGroup: Boolean },
  data() {
    return {
      active: false,
      parameter: "",
      isValid: false,
      pattern: /\/(([a-zA-Z]+)):((["]{1})?([`'])?([a-zA-Z0-9- _\\:.]+)(["]{1})?([`'])?)|\/(([a-zA-Z]+))/g,
      regex: new RegExp(this.pattern),
    };
  },
  computed: {
    store() {
      if (this.isGroup) return "groupPackage";
      else return "computerPackage";
    },
    findParam() {
      return (params) => {
        return findParam(params, `--package-parameters`);
      };
    },
  },

  mounted() {
    this.active = findParam(
      this.item.tempCommand.parameters,
      "--package-parameters"
    )
      ? true
      : false;
  },

  methods: {
    validate(input) {
      const result = input.match(this.pattern);
      if (result && result.length > 0)
        this.parameter = result.map((x) => x.trim()).join(" ");
      else this.parameter = "";

      this.isValid =
        input &&
        this.regex.test(input) &&
        this.parameter.length == input.length;
    },
    clean(item) {
      const currentParam = findParam(
        item.tempCommand.parameters,
        "--package-parameters"
      );

      if (currentParam) {
        const newParams = addTempParam(
          item.tempCommand.parameters,
          currentParam
        );

        this.$store.commit(`${this.store}/editMergedPackage`, {
          p: this.item,
          obj: { tempCommand: null },
        });

        this.$store.commit(`${this.store}/editMergedPackage`, {
          p: this.item,
          obj: { tempCommand: { ...item.tempCommand, parameters: newParams } },
        });
      }
    },
    addTempParam(item, param) {
      const currentParam = findParam(
        item.tempCommand.parameters,
        "--package-parameters"
      );

      let newParams = "";

      if (currentParam) {
        newParams = addTempParam(item.tempCommand.parameters, currentParam);
      } else {
        param = `--package-parameters='"${param.replace(/"/g, '""')}"'`;
        newParams = addTempParam(item.tempCommand.parameters, param);
      }

      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: this.item,
        obj: { tempCommand: { ...item.tempCommand, parameters: newParams } },
      });
    },
  },
};
</script>
